// extracted by mini-css-extract-plugin
module.exports = {"root":"RichText_root__pL4qS"};